module.exports = __webpack_public_path__ + "img/gerenciador-contas-facebook-icon.166c82a6.svg";